const valuetext = value => `${value}$`;

export default valuetext;
